import { pageMaxWidth, pageXPadding } from '@/config'
import { AnimatePresence } from 'framer-motion'
import { useState } from 'react'
import { FaThLarge } from 'react-icons/fa'
import { NavLink } from 'react-router-dom'
import { MobileSidebar } from './MobileSidebar'

export const navLinks = [
  { name: 'Home', path: '.' },
  { name: 'About', path: 'aboutus' },
  { name: 'Portfolio', path: 'portfolio' },
  { name: 'Testimonials', path: 'testimonials' },
  { name: 'Contact', path: 'contact' },
]
export const Navbar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const handleSidebarClose = () => {
    setIsSidebarOpen(false)
  }
  return (
    <>
      <nav
        className={`w-full bg-[#F5F5F5] py-[10px] md:py-[15px] lg:py-[20px] ${pageXPadding}`}
      >
        <div
          className={`mx-auto flex  size-full items-center justify-between ${pageMaxWidth}`}
        >
          {Logo}
          <ul className="hidden md:flex md:gap-x-[20px] lg:gap-x-[40px]">
            {navLinks.map(
              (navLink, index) =>
                navLink.path !== 'contact' && (
                  <NavLink
                    to={navLink.path}
                    key={index}
                    className={({ isActive }) =>
                      isActive
                        ? 'font-nunito select-none text-base font-bold text-[#8C1D40]'
                        : 'font-nunito select-none text-base font-[500] '
                    }
                  >
                    {navLink.name}
                  </NavLink>
                )
            )}
          </ul>
          <NavLink
            to={'contact'}
            className={({ isActive }) =>
              'hidden rounded-[12px] border-[1.5px] border-[#333333] px-[25px] py-[10px] font-nunito text-base text-[#333333] transition-all  hover:border-[#8C1D40] hover:font-bold hover:text-[#8C1D40] md:inline-block' +
              (isActive
                ? ' border-[#8C1D40] font-bold text-[#8C1D40]'
                : ' [font-weight:500]')
            }
          >
            Contact
          </NavLink>
          <FaThLarge
            onClick={() => setIsSidebarOpen(true)}
            size={25}
            className="text-[#333333] md:hidden"
          />
        </div>
      </nav>
      <AnimatePresence>
        {isSidebarOpen && (
          <MobileSidebar isOpen={isSidebarOpen} onClose={handleSidebarClose} />
        )}
      </AnimatePresence>
    </>
  )
}

export const Logo = (
  <span className="cursor-pointer font-normal text-[#D4AF37]">
    <span className="mr-[7px] font-irish ">
      <span className="text-[32px] leading-[38.69px]">R</span>
      <span className="text-2xl leading-[29.02px]">R</span>
    </span>
    <span className="font-inknut text-base leading-[41.26px]">INTERIOR</span>
  </span>
)
